/* ============================================================
   MẶC — trang Sản phẩm và trang Chi tiết
   Cùng ngôn ngữ thiết kế với trang Look: nền trắng ngà, ô ảnh xám
   nhạt như ảnh sản phẩm trong bảng "Mua cả bộ", chữ grotesk đen.
   ============================================================ */
(function () {
  'use strict';
  var MAC = window.MAC, UI = window.MACUI;
  var t = UI.t, chon = UI.chon;

  function lookCua(id) { return MAC.look.filter(function (lk) { return lk.mon.some(function (x) { return x[0] === id; }); }); }
  function nhanLoai(m) { return MAC.loaiTen[m.loai][UI.nn()] + ' · ' + chon(m.mau); }

  /* ---------- một thẻ sản phẩm ---------- */
  function the(id) {
    var m = MAC.mon[id];
    return '<article class="the" data-id="' + id + '">' +
      '<div class="the-khung">' +
        '<a class="the-anh" href="' + UI.duongCT(id) + '" aria-label="' + chon(m.ten) + '">' +
          '<img class="mot" src="' + UI.anhMon(id) + '" alt="" loading="lazy" width="400" height="400">' +
          '<img class="hai" src="' + UI.anhNguoi(m.anh, 800) + '" alt="" loading="lazy">' +
        '</a>' +
        (m.het ? '' :
        '<div class="the-co" hidden role="group" aria-label="Size">' +
          ['S', 'M', 'L'].map(function (s) {
            return '<button type="button" data-co="' + s + '"' + (UI.conHang(id, s) ? '' : ' disabled') + '>' + s + '</button>';
          }).join('') +
        '</div>' +
        '<button type="button" class="the-them" aria-label="' + t('them_mon', { ten: chon(m.ten) }) + '">+</button>') +
      '</div>' +
      '<p class="nhan the-loai">' + nhanLoai(m) + '</p>' +
      '<p class="the-ten"><a href="' + UI.duongCT(id) + '">' + chon(m.ten) + '</a></p>' +
      '<p class="the-gia">' + (m.het ? t('het_hang') : UI.giaHtml(m)) + '</p>' +
    '</article>';
  }

  /* bấm + trên thẻ: hiện ba ô size, chọn là thêm ngay */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('.the-them');
    if (p) {
      var a = p.closest('.the'), co = a.querySelector('.the-co');
      document.querySelectorAll('.the-co').forEach(function (x) { if (x !== co) x.hidden = true; });
      co.hidden = !co.hidden;
      if (!co.hidden) co.querySelector('button:not([disabled])').focus();
      return;
    }
    var c = e.target.closest('[data-co]');
    if (c) {
      var th = c.closest('.the');
      UI.themGio([{ id: th.dataset.id, size: c.dataset.co, sl: 1 }], t('da_them'));
      th.querySelector('.the-co').hidden = true;
    }
  });

  /* ============================================================
     TRANG SẢN PHẨM
     ============================================================ */
  var luoi = document.getElementById('luoi');
  if (luoi) {
    var loc = document.getElementById('loc');
    var dangLoc = 'tat';
    var thuTu = ['ao', 'vay', 'quan', 'corset', 'aodai'];
    function veLoc() {
      loc.innerHTML = ['tat'].concat(thuTu).map(function (k) {
        var ten = k === 'tat' ? t('tat_ca') : (UI.nn() ? MAC.loaiTen[k][2] : MAC.loaiTen[k][0]);
        return '<button type="button" data-loc="' + k + '" aria-pressed="' + (k === dangLoc) + '">' + ten + '</button>';
      }).join('');
    }
    function veLuoi() {
      var ids = Object.keys(MAC.mon).filter(function (id) { return dangLoc === 'tat' || MAC.mon[id].loai === dangLoc; });
      ids.sort(function (a, b) { return thuTu.indexOf(MAC.mon[a].loai) - thuTu.indexOf(MAC.mon[b].loai); });
      luoi.innerHTML = ids.map(the).join('');
      document.getElementById('spDan').textContent = t('sp_dan', { n: Object.keys(MAC.mon).length });
    }
    loc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-loc]');
      if (!b) return;
      dangLoc = b.dataset.loc;
      veLoc(); veLuoi();
    });
    document.addEventListener('mac:ngonngu', function () { veLoc(); veLuoi(); });
    veLoc(); veLuoi();
  }

  /* ============================================================
     TRANG CHI TIẾT
     ============================================================ */
  var ct = document.getElementById('chiTiet');
  if (ct) {
    var id = new URLSearchParams(location.search).get('mon');
    // trang /products/... của Shopify: template đặt sẵn handle và biến thể đang chọn
    if (!MAC.mon[id] && window.MAC_SP_HIEN) id = UI.monTuSP(window.MAC_SP_HIEN.h, window.MAC_SP_HIEN.v);
    if (!MAC.mon[id]) id = Object.keys(MAC.mon)[0];
    var m = MAC.mon[id];
    var size = null;
    var looks = lookCua(id);
    // những màu khác của cùng một sản phẩm (món gộp nhiều màu trên Shopify)
    var cacMau = m.sp ? Object.keys(MAC.mon).filter(function (k) { return MAC.mon[k].sp === m.sp; }) : [id];
    // vị trí pin của món này trên ảnh chính, lấy từ look đầu tiên có nó
    var pin = null;
    looks.forEach(function (lk) {
      if (lk.anh === m.anh) lk.mon.forEach(function (x) { if (x[0] === id) pin = [x[1], x[2]]; });
    });
    var anhDs = [m.anh].concat(m.phu || []);

    function veCT() {
      document.title = chon(m.ten) + ' — Mặc';
      // nút "Xem cả bộ" phải trỏ tới đúng look đang hiện trong ảnh lớn; một món có thể
      // nằm trong nhiều look (chân váy bồng có ở cả look 06 và 08), nên không lấy bừa look đầu
      var lk = looks.find(function (l) { return l.anh === m.anh; }) || looks[0];
      ct.innerHTML =
        '<div>' +
          '<div class="ct-anh" id="ctAnh">' +
            '<div class="ct-khung" style="position:relative;height:94%">' +
              '<img src="' + UI.anhNguoi(anhDs[0]) + '" alt="' + chon(m.ten) + '" style="height:100%;width:auto">' +
              (pin ? '<span class="pin" style="left:' + pin[0] + '%;top:' + pin[1] + '%;opacity:1;transform:none;pointer-events:none" aria-hidden="true">1</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="ct-nho" role="group" aria-label="Ảnh">' +
            anhDs.map(function (n, i) {
              return '<button type="button" data-anh="' + n + '" aria-current="' + (i === 0) + '"><img src="' + UI.anhNguoi(n, 800) + '" alt=""></button>';
            }).join('') +
            '<button type="button" data-anh="mon" aria-current="false"><img src="' + UI.anhMon(id) + '" alt=""></button>' +
          '</div>' +
        '</div>' +
        '<div class="ct-ben">' +
          '<p class="nhan">' + nhanLoai(m) + '</p>' +
          '<h1 style="margin-top:10px">' + chon(m.ten) + '</h1>' +
          '<p class="ct-gia">' + UI.giaHtml(m) + '</p>' +
          '<div class="co" role="group" aria-label="Size"><span class="nhan">' + t('size') + '</span>' +
            ['S', 'M', 'L'].map(function (s) {
              return '<button type="button" aria-pressed="' + (s === size) + '"' + (UI.conHang(id, s) ? '' : ' disabled') + '>' + s + '</button>';
            }).join('') +
          '</div>' +
          '<p class="co-nhac" role="alert">' + t('chon_size') + '</p>' +
          (m.het
            ? '<button type="button" class="nut" disabled>' + t('het_hang') + '</button>'
            : '<button type="button" class="nut" id="ctThem"><span>' + t('them_gio') + '</span><span class="mui-ngang" aria-hidden="true">&#8594;</span></button>') +
          (lk ? '<a class="nut vien" style="margin-top:10px" href="' + UI.duongLook(lk.so) + '">' + t('xem_ca_bo') + ' · Look ' + lk.so + ' ' + chon(lk.ten) + '</a>' : '') +
          '<div class="ct-mo"><dl>' +
            '<dt>' + t('mau') + '</dt><dd>' + cacMau.map(function (k) {
              return k === id ? chon(MAC.mon[k].mau)
                : '<a href="' + UI.duongCT(k) + '" style="text-decoration:underline;text-underline-offset:3px">' + chon(MAC.mon[k].mau) + '</a>';
            }).join(' · ') + '</dd>' +
            '<dt>' + t('chat_lieu') + '</dt><dd>' + t('lua') + '</dd>' +
            '<dt>' + t('may') + '</dt><dd>' + t('may_v') + '</dd>' +
            '<dt>' + t('doi') + '</dt><dd>' + t('doi_v') + '</dd>' +
            (looks.length ? '<dt>' + t('trong_look') + '</dt><dd>' + looks.map(function (l) {
              return '<a href="' + UI.duongLook(l.so) + '" style="text-decoration:underline;text-underline-offset:3px">Look ' + l.so + ' ' + chon(l.ten) + '</a>';
            }).join(', ') + '</dd>' : '') +
          '</dl></div>' +
        '</div>';

      // phối cùng: những món khác nằm chung look với món này
      var cung = [];
      looks.forEach(function (l) { l.mon.forEach(function (x) { if (x[0] !== id && cung.indexOf(x[0]) < 0) cung.push(x[0]); }); });
      var ph = document.getElementById('phoi');
      if (cung.length) {
        ph.hidden = false;
        ph.querySelector('h2').textContent = t('phoi_cung');
        ph.querySelector('.luoi').innerHTML = cung.map(the).join('');
      } else ph.hidden = true;
    }

    ct.addEventListener('click', function (e) {
      var a = e.target.closest('[data-anh]');
      if (a) {
        var n = a.dataset.anh;
        var khung = ct.querySelector('.ct-khung');
        khung.querySelector('img').src = n === 'mon' ? UI.anhMon(id) : UI.anhNguoi(n);
        var p = khung.querySelector('.pin');
        if (p) p.style.display = String(n) === String(m.anh) ? '' : 'none';
        ct.querySelectorAll('[data-anh]').forEach(function (b) { b.setAttribute('aria-current', String(b === a)); });
        return;
      }
      var c = e.target.closest('.co button');
      if (c) {
        size = c.textContent;
        ct.querySelectorAll('.co button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === c)); });
        ct.querySelector('.co').classList.remove('nhac');
        return;
      }
      if (e.target.closest('#ctThem')) {
        if (!size) {
          var co = ct.querySelector('.co');
          co.classList.remove('nhac'); void co.offsetWidth; co.classList.add('nhac');
          co.querySelector('button:not([disabled])').focus();
          return;
        }
        UI.themGio([{ id: id, size: size, sl: 1 }], t('da_them'));
      }
    });
    document.addEventListener('mac:ngonngu', veCT);
    veCT();
  }
})();
